import $ from 'jquery';
import plugin from '@core/plugins/lib';
const PLUGIN_NAME = 'stickyNavigation';
/**
 * Sticky Navigation
 */

class StickyNavigation {

    constructor (element) {
        this.element = element;
        this.$element = $(element);
        this.$viewportElement = $('[data-sticky-nav-viewport-element]');
        this.executeFunction;
        this.timeToExecute = 200;

        this.watch();
    }

    onScroll () {
        clearTimeout(this.executeFunction);
        var plug = this;
        this.executeFunction = setTimeout(function(){
            if (plug.$viewportElement.length > 0) {
                var viewportElementVisible = true;
                var offsetTop = $(window).scrollTop();
                var viewportElementOffsetTop = plug.$viewportElement.offset().top;
                plug.$element.removeClass('active');
                if (!plug.isElementInViewport() && offsetTop > viewportElementOffsetTop) {
                    viewportElementVisible = false;
                }

                if (!viewportElementVisible) {
                    plug.$element.addClass('active');
                }
            }
        }, this.timeToExecute);
    }

    isElementInViewport () {
        var el = this.$viewportElement;

        //special bonus for those using jQuery
        el = el[0];
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    }

    watch () {
        $(window).on('scroll', this.onScroll.bind(this));
    }

    unwatch () {
        $(window).off('scroll', this.onScroll.bind(this));
        log('unbound', this.$element);
    }

}

plugin(PLUGIN_NAME, StickyNavigation);

$(document).ready(() => {
    $(".sticky-navigation").stickyNavigation();
});




// WEBPACK FOOTER //
// ./client/src/core/components/sticky-navigation/index.js